{{(!isAuthenticated) ? translationService.getTranslation('login') : translationService.getTranslation('logout')}}

